import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import { ComponentProps } from 'types/index';
import { useProtocolStore } from 'lib/store/protocol';
import { useMobileStore } from 'lib/store/mobileStore';
import Protocol from 'lib/components/Protocol';
import { rem } from 'lib/utils/util';
import './index.scss';

interface ProtocolProps {
  showDefaultText: boolean;
  defaultText: string;
  protocolShortText: string;
  protocolText: string;
  expandTextColor?: string;
  checkboxBorderColor?: string;
  isDebugMode?: boolean;
}

export default function ProtocolComponent({ data, style, commonStyle }: ComponentProps<ProtocolProps>) {
  const {
    showDefaultText,
    defaultText,
    protocolText,
    protocolShortText,
    expandTextColor,
    checkboxBorderColor,
    isDebugMode,
  } = data;
  const { fontSize = 20, defaultTextFontSize = 20 } = style;
  const { setProtocolText } = useProtocolStore();
  const useGatewayMobile = useMobileStore((state) => state.useGatewayMobile);

  useEffect(() => {
    setProtocolText({ protocolShortText, protocolText });
  }, [protocolShortText, protocolText]);

  if ((process.env.IS_EDITOR && isDebugMode) || (!process.env.IS_EDITOR && !useGatewayMobile)) {
    return showDefaultText ? (
      <div
        className="protocol-component"
        style={{ ...commonStyle, ...(defaultTextFontSize ? { fontSize: rem(defaultTextFontSize) } : {}) }}
      >
        <div
          className="default-text"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(defaultText),
          }}
        />
      </div>
    ) : null;
  }

  return (
    <div className="protocol-component" style={commonStyle}>
      <Protocol fontSize={fontSize} expandTextColor={expandTextColor} checkboxBorderColor={checkboxBorderColor} />
    </div>
  );
}
